// extracted by mini-css-extract-plugin
export default {"pageWrap":"Cd-z","fullWidth":"Dd-z","heading":"Ed-z","fullBleed":"Fd-z","hidden":"Gd-z"};